// extracted by mini-css-extract-plugin
export default {"copyrightContainer":"Copyright_copyrightContainer__Ooy0w"};